import React from "react";
import styled from "styled-components";
import { Heading, Text, BaseLayout } from "@pancakeswap-libs/uikit";
import Page from "components/layout/Page";
import FarmStakingCard from "./components/FarmStakingCard";
import CakeStats from "./components/CakeStats";
import TotalValueLockedCard from "./components/TotalValueLockedCard";
import TwitterCard from "./components/TwitterCard";
import ChainDominance from "./components/ChainDominance";
import BuyVempLinks from "./components/BuyVempLinks";

const Hero = styled.div`
  align-items: center;
  //  background-image: url('/images/egg/3.png');
  background-repeat: no-repeat;
  background-position: top center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: auto;
  margin-bottom: 32px;
  padding-top: 25px;
  text-align: center;
  /* font-family: "Cinzel Decorative", cursive !important; */
  ${({ theme }) => theme.mediaQueries.lg} {
    // background-image: url('/images/egg/3.png'), url('/images/egg/3b.png');
    background-position: left center, right center;
    /* height: 165px; */
    padding-top: 0;
  }
`;

const Cards = styled(BaseLayout)`
  align-items: stretch;
  justify-content: stretch;
  margin-bottom: 48px;

  & > div {
    grid-column: span 6;
    width: 100%;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    & > div {
      grid-column: span 12;
    }
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    & > div {
      grid-column: span 6;
    }
  }
`;
export interface HomeProps {
  webInstance?: any;
}

const Home: React.FC<HomeProps> = ({webInstance}) => {

  return (
    <Page>
      <Hero>
        <Heading
          style={{ fontSize: "35px", fontWeight: 600 }}
          size="xl"
          mb="24px"
          color="secondary"
        >
          <span>v</span>
          <span>Empire DDAO</span>
        </Heading>
        <Text style={{ fontWeight: 600, fontSize: "20px" }}>
          vEmpire DDAO is the world’s largest Decentralized Metaverse Investment
          Organization. The official vEmpire protocol incorporates different
          strategies to incentivize Metaverse token staking to fund the battle
          against centralisation.
        </Text>
      </Hero>
      <div>
        <Cards>
          <FarmStakingCard webInstance={webInstance}/>
          <div>
            <TotalValueLockedCard />
            <CakeStats />
          </div>
          <TwitterCard />
          <ChainDominance />
        </Cards>
        <BuyVempLinks />
      </div>
    </Page>
  );
};

export default Home;
